import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TechTabsModule } from '@tech/components/tech-tabs';
import { TechIconModule } from '@tech/components/tech-icon';

import { HomeComponent } from '@app/features/receipts/pages/home/home.component';
import { ReceiptAccountComponent } from '@app/features/receipts/pages/receipt-account/receipt-account.component';
import { ReceiptAccountReturnComponent } from '@app/features/receipts/pages/receipt-account-return/receipt-account-return.component';
import { ReceiptCardComponent } from '@app/features/receipts/pages/receipt-card/receipt-card.component';
import { ReceiptCardReturnComponent } from '@app/features/receipts/pages/receipt-card-return/receipt-card-return.component';
import { ReceiptPaypalComponent } from '@app/features/receipts/pages/receipt-paypal/receipt-paypal.component';
import { ReceiptTransferComponent } from '@app/features/receipts/pages/receipt-transfer/receipt-transfer.component';
import { ReceiptReturnComponent } from '@app/features/receipts/pages/receipt-return/receipt-return.component';
import { ReceiptLatamComponent } from '@app/features/receipts/pages/receipt-latam/receipt-latam.component';

@Component({
  selector: 'receipts-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TechTabsModule,
    TechIconModule,
    HomeComponent,
    ReceiptAccountComponent,
    ReceiptAccountReturnComponent,
    ReceiptCardComponent,
    ReceiptCardReturnComponent,
    ReceiptPaypalComponent,
    ReceiptTransferComponent,
    ReceiptReturnComponent,
    ReceiptLatamComponent,
    TranslateModule,
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  isInsideNavbar = true;
  isInHoverZone = true;
  tabSelected: number = 0;

  ngOnInit(): void {
    document.getElementById('navbar')?.classList.remove('collapsed');
  }

  enterNavbar() {
    this.isInsideNavbar = true;
    this.isInHoverZone = true;
    document.getElementById('navbar')?.classList.remove('collapsed');
  }

  onHoverZoneEnter() {
    this.isInHoverZone = true;
    if (this.isInHoverZone || this.isInsideNavbar)
      document.getElementById('navbar')?.classList.remove('collapsed');
  }

  onHoverZoneLeave() {
    this.isInHoverZone = false;
    if (this.isInsideNavbar && !this.isInHoverZone) {
      document.getElementById('navbar')?.classList.add('collapsed');
      this.isInsideNavbar = false;
    }
  }
}
